import { render, staticRenderFns } from "./activityCreateAssignments.html?vue&type=template&id=2706c726&external"
import script from "./activityCreateAssignments.vue?vue&type=script&lang=js"
export * from "./activityCreateAssignments.vue?vue&type=script&lang=js"
import style0 from "./activityCreateAssignments.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports